import React from 'react'
import { Link } from "react-router-dom"
import { useLocation } from 'react-router-dom'
import odotimg from '../assets/odot.png'

export default function Navbar() {

    const location = useLocation();

    const { pathname } = location;

    const splitLocation = pathname.split("/");

    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-dark" id="navbar" style={{ backgroundColor: "#124c7c" }}>
                <div className="container mb-2">
                    <div className='row'>
                        <div className='col-4'>
                            <a className="navbar-brand" href="https://oklahoma.gov/odot/" rel="noreferrer" target='_blank'>
                                <img src={odotimg} style={{ width: "50px" }} alt="ODOT Logo" />
                            </a>
                        </div>
                        <div className='col-4'>
                            <div className="fw-bold navbar-nav" style={{ fontSize: '20px' }}>
                                <Link className="nav-link" id={(splitLocation[1] === "" ? "active" : "")} to="/" >Home</Link>
                            </div>
                        </div>
                        <div className='col-4'>
                            <div className="fw-bold navbar-nav" style={{ fontSize: '20px' }}>
                                <Link className="nav-link" id={(splitLocation[1] === "Map" ? "active" : "")} to="/Map" >Map</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    )
}